import React, { PureComponent } from 'react';
import {
  PieChart, Pie, Cell, ResponsiveContainer, Tooltip
} from 'recharts';
import { Popup } from 'semantic-ui-react';
import { __ } from '../lib/I18n';
import { percent } from '../lib/Util';

export default class PizzaChart extends PureComponent {
  render() {
    const {
      confirmed, symptoms, contact, safe, numberOfStudents
    } = this.props;

    const numberAnswered = confirmed + symptoms + contact + safe;

    const data = [
      { name: __('Seguros'), value: safe, color: '#40ab4c' },
      { name: __('Casos confirmados'), value: confirmed, color: '#eb3322' },
      { name: __('Sintomáticos no grupo familiar'), value: symptoms, color: '#f3a540' },
      { name: __('Exposição a casos confirmados'), value: contact, color: '#e4e426' },
      {
        name: __('Não responderam'), value: numberOfStudents - safe - contact - confirmed - symptoms, color: '#e0e0e0', formated: false
      }
    ];

    return (
      <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 20 }}>
        <div style={{ position: 'relative' }}>
          <div style={{ width: 200, height: 200 }}>
            <ResponsiveContainer>
              <PieChart onMouseEnter={this.onPieEnter}>
                <Pie
                  data={data}
                  innerRadius={60}
                  outerRadius={100}
                  fill="#8884d8"
                  dataKey="value"
                  animationDuration={400}
                  animationBegin={0}
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={entry.color}
                      style={{ zIndex: 100 }}
                    />
                  ))}
                </Pie>
                <Tooltip
                  style={{ position: 'relative', top: -100, fontSize: 11 }}
                  wrapperStyle={{ zIndex: 1000 }}
                  formatter={(value, _, { payload }) => {
                    if (payload && payload.formated === false) return value;
                    if (value == 1) return __('1 registro');
                    return __('%s registros', value);
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="chart-pie-label" style={{ color: '#40ab4c' }}>{numberAnswered ? __('%s Seguros', percent(safe, numberOfStudents)) : null}</div>
        </div>
        <div style={{
          flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'
        }}
        >
          {data.map((payload) => {
            const { name, value, color } = payload;
            const description = __(name) + ': ' + value;

            return (
              <div key={name} style={{ display: 'flex', flexDirection: 'row', margin: '3px 0' }}>
                <Popup
                  content={description}
                  key={description}
                  trigger={(
                    <div style={{
                      flexShrink: 0, width: 15, height: 15, background: color, margin: '3px 10px 0 35px'
                    }}
                    />
                  )}
                  basic
                  wide="very"
                  position="top center"
                />
                <div style={{
                  display: 'inline-block', color: '#444', fontSize: 12
                }}
                >
                  {percent(value, numberOfStudents)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
